import { useState, useEffect } from 'react';
import { subscribeRow } from '../lib/db';
import { SystemSettings } from '../types';

export function useClosingDate(userId: string | undefined) {
  const [closingDate, setClosingDate] = useState<string>('1900-01-01');

  useEffect(() => {
    if (!userId) {
      setClosingDate('1900-01-01');
      return;
    }

    // Subscribe to changes in settings
    const unsubscribe = subscribeRow<Partial<SystemSettings>>(
      'settings',
      'userId',
      userId,
      (row) => {
        if (row?.closingDate) {
          setClosingDate(row.closingDate);
        } else {
          setClosingDate('1900-01-01'); // Fallback si no hay settings o no hay fecha
        }
      },
      (error) => {
        console.error('Error fetching closing date:', error);
        setClosingDate('1900-01-01');
      },
    );

    return () => unsubscribe();
  }, [userId]);

  return closingDate;
}
